"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowsId = exports.getNewMassActionCheckValue = exports.quantitySelected = exports.createSelectedValues = void 0;

var createSelectedValues = function createSelectedValues(length, value) {
  var values = [];

  for (var i = 0; i < length; i++) {
    values[i] = value;
  }

  return values;
};

exports.createSelectedValues = createSelectedValues;

var quantitySelected = function quantitySelected(rows) {
  var rowsSelected = 0;

  for (var i = 0; i < rows.length; i++) {
    if (rows[i]) rowsSelected++;
  }

  return rowsSelected;
};

exports.quantitySelected = quantitySelected;

var isNoneSelected = function isNoneSelected(rows) {
  return quantitySelected(rows) === 0;
};

var isAllSelected = function isAllSelected(rows) {
  return quantitySelected(rows) === rows.length;
};

var getNewMassActionCheckValue = function getNewMassActionCheckValue(rows) {
  if (isAllSelected(rows)) {
    return true;
  }

  if (isNoneSelected(rows)) {
    return false;
  }

  return "indeterminate";
};

exports.getNewMassActionCheckValue = getNewMassActionCheckValue;

var getRowsId = function getRowsId(rows) {
  var rowsId = [];

  for (var i = 0; i < rows.length; i++) {
    if (rows[i]) rowsId.push(i);
  }

  return rowsId;
};

exports.getRowsId = getRowsId;